module.exports = __webpack_public_path__ + "assets/google_form_logo.fff7f860.svg";